<app-sidebar-atricon></app-sidebar-atricon>
<app-navbar-atricon></app-navbar-atricon>
<router-outlet></router-outlet>